import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-offers-mail-upload-file-modal',
  templateUrl: './offers-mail-upload-file.component.html',
  styleUrls: ['../modal.component.scss']
})

export class OfferMailUploadFileModalComponent {
  uploadedFiles: Array<any> = [];
  @Output() readonly responseChanged = new EventEmitter();

  handleFileChange(event: any): void {
    if (event.target.files && event.target.files.length) {
      for (let doc of event.target.files) {
        this.uploadedFiles.push(doc);
      }
    }
  }

  onRemoveFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
  }

  emitTrue(): void {
    this.responseChanged.emit(this.uploadedFiles);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }

  calculateFilesSize(): {size: string, tooBig: boolean } | null {
    const filesSizeKb = this.uploadedFiles.reduce((acc, current) => acc + current.size, 0) / 1024;
    if (filesSizeKb === 0) {
      return null;
    }
    
    const filesSizeStr = filesSizeKb > 1024 ? 
                (filesSizeKb / 1024).toFixed(2) + ' MB' :
                (filesSizeKb).toFixed(2) + ' KB';
    const tooBig = filesSizeKb > 1024 * 30; // 30MB
                
    return {size: filesSizeStr, tooBig: tooBig};
  }
}